import { Box } from '@arpeggi/ui'
import { FC, PropsWithChildren } from 'react'
import GenresDropdown from '../../../__legacy__/components/platform/new-explore/components/GenresDropdown'
import InstrumentDropdown from '../../../__legacy__/components/platform/new-explore/components/InstrumentDropdown'
import KeyDropdown from '../../../__legacy__/components/platform/new-explore/components/KeyDropdown'
import TypeDropdown from '../../../__legacy__/components/platform/new-explore/components/TypeDropdown'
import { DEFAULT_SOUNDS_TYPES, TypeSubtype } from '../hooks'
import { useArpTableContext } from './ArpTableContext'
import { Tags } from './Tags'

const Key: FC = () => {
  const { filters, updateFilters } = useArpTableContext()
  const { key } = filters
  const handleSelect = (_selected: number) => {
    if (_selected === key) return updateFilters({ key: undefined })
    updateFilters({ key: _selected })
  }
  return <KeyDropdown _key={key} onSelect={handleSelect} />
}

const Genre: FC = () => {
  const { filters, updateFilters } = useArpTableContext()
  const { genre } = filters
  const handleSelect = (_selected: string) => {
    const draft = new Set(genre)
    if (draft.has(_selected)) draft.delete(_selected)
    else draft.add(_selected)
    updateFilters({ genre: Array.from(draft) })
  }
  return <GenresDropdown genres={genre} onSelect={handleSelect} />
}

const Instrument: FC = () => {
  const { filters, updateFilters } = useArpTableContext()
  const { tag } = filters
  const handleSelect = (_selected: string[]) => {
    const draft = new Set(tag)
    _selected.forEach((instrument) => {
      if (draft.has(instrument)) draft.delete(instrument)
      else draft.add(instrument)
    })
    updateFilters({ tag: Array.from(draft) })
  }
  return <InstrumentDropdown selected={tag} onSelect={handleSelect} />
}

const Type: FC = () => {
  const { filters, updateFilters, defaultFilters } = useArpTableContext()
  const { typesAndSubTypes } = filters
  const handleSelect = (_selected: TypeSubtype) => {
    if (typesAndSubTypes === defaultFilters.typesAndSubTypes)
      return updateFilters({ typesAndSubTypes: [_selected] })
    const draft = new Set(typesAndSubTypes)
    if (draft.has(_selected)) draft.delete(_selected)
    else draft.add(_selected)
    if (draft.size === 0)
      return updateFilters({ typesAndSubTypes: defaultFilters.typesAndSubTypes })
    updateFilters({ typesAndSubTypes: Array.from(draft) })
  }
  return (
    <TypeDropdown
      filters={typesAndSubTypes || []}
      onSelect={handleSelect}
      defaultFilter={DEFAULT_SOUNDS_TYPES}
    />
  )
}

const Root: FC<PropsWithChildren<{ tags?: boolean }>> = ({ children, tags }) => (
  <Box>
    <Box row alignCenter css={{ gap: '4px', marginBottom: '12px' }}>
      {children}
    </Box>
    <Tags />
  </Box>
)

export const Filters = { Root, Key, Genre, Instrument, Type }
